import { Sparkles, Trophy, TreePine, UserPlus, Users } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { cn } from '@/lib/utils'
import type { AppNotification, NotificationType } from '@/api/notifications'

const TYPE_ICON: Record<NotificationType, React.ReactNode> = {
  trophy_unlocked:    <Trophy size={18} className="text-yellow-500" />,
  tree_unlocked:      <TreePine size={18} className="text-green-500" />,
  ai_rating_complete: <Sparkles size={18} className="text-blue-500" />,
  friend_request:     <UserPlus size={18} className="text-indigo-500" />,
  friend_accepted:    <Users size={18} className="text-indigo-500" />,
}

function relativeTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime()
  const m = Math.floor(diff / 60000)
  if (m < 1)  return 'たった今'
  if (m < 60) return `${m}分前`
  const h = Math.floor(m / 60)
  if (h < 24) return `${h}時間前`
  return `${Math.floor(h / 24)}日前`
}

type Props = {
  notification: AppNotification
  onRead: (id: number) => void
  onClose: () => void
}

export default function NotificationItem({ notification, onRead, onClose }: Props) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (!notification.is_read) onRead(notification.id)
    onClose()
    if (notification.type === 'friend_accepted') {
      // 一覧を履歴に挟んでからプロフィールへ（戻るでフレンド一覧に戻る）
      navigate('/friends')
      navigate(notification.target_url)
    } else {
      navigate(notification.target_url)
    }
  }

  return (
    <button
      type="button"
      onClick={handleClick}
      className={cn(
        'w-full flex items-start gap-3 px-4 py-3 text-left transition-colors hover:bg-muted/50',
        !notification.is_read && 'bg-muted/30',
      )}
    >
      <span className="mt-0.5 shrink-0">
        {TYPE_ICON[notification.type]}
      </span>
      <div className="flex-1 min-w-0">
        <p className={cn('text-sm leading-snug', !notification.is_read && 'font-medium')}>
          {notification.title}
        </p>
        {notification.body && (
          <p className="text-xs text-muted-foreground mt-0.5 line-clamp-2">{notification.body}</p>
        )}
        <p className="text-xs text-muted-foreground mt-1">{relativeTime(notification.created_at)}</p>
      </div>
      {!notification.is_read && (
        <span className="mt-1.5 shrink-0 w-2 h-2 rounded-full bg-primary" />
      )}
    </button>
  )
}
